import React from 'react';

import { Box, Typography } from '@mui/material';

import {
  Reason,
  ReasonsTransform,
} from '../../../../../common/constants/reasons';
import { Resource } from '../../../../../common/constants/resource';
import { MibCodeDetails } from '../../../../tasks/types/mibCodeDetails';

export const MibCodeDetailsSummary = ({
  title,
  data,
}: {
  title: string;
  data: MibCodeDetails;
}) => {
  const transformedReasons: Reason[] = (data.reason || []).map(item => {
    return ReasonsTransform.getReason(item) as Reason;
  });

  return (
    <Box mt={5}>
      <Box>
        <Typography variant="h3">{title}</Typography>
      </Box>
      <Box mt={2}>
        <Typography variant="body1" gutterBottom>
          {Resource.MIB_CODE}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2">{data.code}</Typography>
      </Box>

      <Box mt={2}>
        <Typography variant="body1">{Resource.ORDER_REASON}</Typography>
      </Box>
      <Box my={1} ml={1.75}>
        <ul style={{ padding: 0, margin: 0 }}>
          {transformedReasons.map(reason => (
            <li key={reason.key}>
              <Typography variant="body2">{reason.displayName}</Typography>
            </li>
          ))}
        </ul>
      </Box>
      <Box>
        <Typography variant="body2">{data.reasonDescription}</Typography>
      </Box>
    </Box>
  );
};
